export const STORAGE_KEYS = {
  USER: 'app_egtec_auth_user',
  MENU: 'app_egtec_menu',
  CURRENT_MENU: 'app_egtec_current_menu'
} as const;
